// The location bar under the panel's header, on a brand with several locations (D4). Wording from the Amigo design's
// copy sheet (Location bar).
export default {
  label: 'Lokalizacja',
  all_one: 'Wszystkie lokalizacje: {{count}}',
  all_few: 'Wszystkie lokalizacje: {{count}}',
  all_many: 'Wszystkie lokalizacje: {{count}}',
  all_other: 'Wszystkie lokalizacje: {{count}}',
};
